import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var StopOutlineSVG = function StopOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 5V27l.2.1H26.9l.1-.2V5.2 5l-.2-.1H5.2 5zm-2 .2C3 4 4 3 5.2 3h21.6C28 3 29 4 29 5.2v21.6c0 1.2-1 2.2-2.2 2.2H5.2C4 29 3 28 3 26.8V5.2z",
    clipRule: "evenodd",
    stroke: "none"
  }));
};
StopOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(StopOutlineSVG);